import { Link, useLocation } from "react-router-dom";

import { IMAGES } from "../../constant/theme";
import { useEffect, useState } from "react";
import { Collapse } from "react-bootstrap";
import { getCoachAttendance } from "../../../services/academicService";
import { formatHoursMinutes } from "../../../utils/helperFunction";

const AboutStaff = () => {
  const location = useLocation();
  const [open2, setOpen2] = useState(true);
  const [userTenant, setUserTenant] = useState(null);

  function StaffProfile() {
    const location = useLocation();
    const [userData, setUserData] = useState(null);

    useEffect(() => {
      setUserData(location.state?.user || null);
    }, [location.state]);

    // const userData = location.state?.user || null;

    // Prepare personal detail items dynamically
    const personalDetail = [
      { title: "Name", subtitle: userData?.name || "-" },
      { title: "Phone", subtitle: userData?.phoneNumber || "-" },
      { title: "email", subtitle: userData?.email || "-" },
      { title: "Gender", subtitle: userData?.sex || "-" },
      { title: "Date of Birth", subtitle: userData?.dob || "-" },
      { title: "Education", subtitle: userData?.education || "-" },
      { title: "Date of Joining", subtitle: userData?.joiningDate || "-" },
      { title: "Department", subtitle: userData?.department || "-" },
      { title: "Designation", subtitle: userData?.designation || "-" },
      { title: "Address", subtitle: userData?.address || "-" },
    ];

    return (
      <>
        <div className="row">
          <div className="col-xl-11 col-xxl-12 col-lg-12">
            <div className="row">
              <div className="col-lg-12">
                <div className="card overflow-hidden">
                  <div
                    className="text-center p-3 overlay-box"
                    style={{ backgroundImage: `url(${IMAGES.BigImg1})` }}
                  >
                    <div className="profile-photo"></div>
                    <h3 className="mt-3 mb-1 text-white">
                      {userData?.name || "-"}
                    </h3>
                    <p className="text-white mb-0">Staff</p>
                  </div>
                  <div className=" row">
                    {personalDetail?.map((data, index) => (
                      <div
                        key={index}
                        className="list-group-item d-flex justify-content-between col-md-6 col-6"
                      >
                        <span className="mb-0">{data.title}</span>{" "}
                        <strong className="text-muted">{data.subtitle}</strong>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <div className="page-titles d-flex justify-content-between align-items-center">
        <h4 className="mb-0">About Staff</h4>
        <ol className="breadcrumb mb-0">
          <li className="breadcrumb-item ">
            <Link to="/admin/all-staff">Staff</Link>
          </li>
          <li className="breadcrumb-item active">
            <Link
              onClick={(e) => e.preventDefault()}
              to="#"
              style={{
                pointerEvents: "none",
                color: "inherit",
                color: "#6F77F8",
              }}
            >
              About Staff
            </Link>
          </li>
        </ol>
      </div>
      <StaffProfile />
    </>
  );
};

export default AboutStaff;
